import {QuestionBase} from "./question-base";

export class SelectRelatedDescription extends QuestionBase<string> {
  override controlType = 'selectrelateddescription';
}
